var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Accordeon extends Component {
    constructor(isDebugEnabled = false) {
        super('Accordeon', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const hash = location.hash;
            if (hash.search('term_id') == 1 && !$('body').hasClass('page-template-page-template-list-references')) {
                const target = $('#accordeon_' + hash.replace('#', ''));
                const targetTitle = target.parents('.module-accordeons').find('h1');
                target.find('[data-bs-toggle="collapse"]').trigger('click');
                setTimeout(() => {
                    $.scrollTo(targetTitle.position().y - $('header').height() - 30);
                }, 500);
            }
            this.success();
        });
    }
}
